/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewkpiherenow3Inputs */

const en_overviewkpiherenow3 = /** @type {(inputs: Overviewkpiherenow3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here now`)
};

const de_overviewkpiherenow3 = /** @type {(inputs: Overviewkpiherenow3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade da`)
};

/**
* | output |
* | --- |
* | "Here now" |
*
* @param {Overviewkpiherenow3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewkpiherenow3 = /** @type {((inputs?: Overviewkpiherenow3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewkpiherenow3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewkpiherenow3(inputs)
	return de_overviewkpiherenow3(inputs)
});
export { overviewkpiherenow3 as "overviewKpiHereNow" }